import { dispatch } from '@ngneat/effects';
import { getCurrentAuthenticatedUser } from '@tmx/auth';

import { SecondaryNavKey } from '../../../components/secondary-nav/models/secondary-nav-key';
import { setSecondaryNavOptions } from '../../../components/secondary-nav/repositories/secondary-nav.actions';
import { ALK_ROLES } from '../../../models/alk-roles';
import { COMPANY_ADMIN, COMPANY_USER } from '../../../models/ams-roles';
import { CompanyType } from '../../../models/company-type';
import { FLEET_MANAGER, FLEET_SUPPORT } from '../../../models/fleet-roles';
import { PARTNER_ROLES } from '../../../models/partner-roles';
import { accountSummarySnapshot } from '../../../repositories/ams/ams.repository';
import {
  isFleetPortalOnly,
  partnerSettingsSnapshot,
} from '../../../repositories/app-settings/app-settings.repository';
import { boolDefinedAndTrue } from '../../../utils/bool-defined-and-true';
import { composeRoles } from '../../../utils/compose-roles';

export function initSecondaryNavManageAccount() {
  const partnerRoles = isFleetPortalOnly() ? new Set<string>() : PARTNER_ROLES;
  const amsRoles = isFleetPortalOnly()
    ? new Set<string>()
    : [COMPANY_ADMIN, COMPANY_USER];
  const hasUserAccessRole = composeRoles(
    ALK_ROLES,
    partnerRoles,
    amsRoles,
    FLEET_MANAGER,
    FLEET_SUPPORT
  );
  const userAccessEnabled = hasUserAccessRole(
    getCurrentAuthenticatedUser().roles
  );

  const hasAlkRole = composeRoles(ALK_ROLES);
  const vehicleTransferEnabled =
    hasAlkRole(getCurrentAuthenticatedUser().roles) &&
    accountSummarySnapshot().companyType === CompanyType.Partner &&
    partnerSettingsSnapshot().integrationType === 'VehicleId';

  dispatch(
    setSecondaryNavOptions({
      key: SecondaryNavKey.ManageAccount,
      options: [
        {
          url: 'manage-account/account-settings',
          displayName: 'Account Settings',
          disabled: false,
        },
        {
          url: 'manage-account/user-access',
          displayName: 'User Access',
          disabled: !userAccessEnabled,
        },
        {
          url: 'manage-account/vehicle-transfer',
          displayName: 'Vehicle Transfer',
          disabled: !vehicleTransferEnabled,
        },
      ].filter((option) => !boolDefinedAndTrue(option.disabled)),
    })
  );
}
